























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ripple from "./ripple.vue";
import tableRow from "./tableRow.vue";
import {HTTPPostAPI} from "../lib/httpapi"

export type Rows = HTTPPostAPI["jobs/list"]["result"]["jobs"][0];

@Component({
    components: {
        ripple,
        tableRow
    }
})
export default class gTable extends Vue {

    @Prop({}) rows:Rows


    mounted(){
        this.sort(2);
    }

    sortable : {
        name: boolean,
        client: boolean,
        date: boolean,
    } = {
        name: false,
        client: false,
        date: true,
    }


    descending:boolean = false;
    previousSort:number = 0;
    sort(x, direction?){
        if(x == this.previousSort && this.descending == false){
            this.descending = true;
        }else this.descending = false;
        
        this.previousSort = x;

        // by default, sorts by date (closest at top) => (MOUNTED REFERENCE)

        this.sortable.name = false;
        this.sortable.client = false;
        this.sortable.date = false;

        if(x == 0){
            this.sortable.name = true;
            (this.rows as any).sort((a,b) => {
                var x = a.distributionName.toLowerCase();
                var y = b.distributionName.toLowerCase();
                if(this.descending){
                    return x < y ? 1 : x > y ? -1 : 0;
                }else{
                    return x < y ? -1 : x > y ? 1 : 0;
                }
            });
        }else if(x == 1){
            this.sortable.client = true;
            (this.rows as any).sort((a,b) => {
                var x = a.clientName.toLowerCase();
                var y = b.clientName.toLowerCase();
                if(this.descending){
                    return x < y ? 1 : x > y ? -1 : 0;
                }else{
                    return x < y ? -1 : x > y ? 1 : 0;
                }
            });
        }else if(x == 2){
            this.sortable.date = true;
            (this.rows as any).sort((a,b) => {
                if(this.descending){
                    return (b.startsAt as any) - (a.startsAt as any);
                }else{
                    return (a.startsAt as any) - (b.startsAt as any);
                }
            });
        }
        
    }

}
